'use client';

import React from 'react';
import { Container } from 'components/shared';
import { useTranslations } from 'next-intl';
import { UHLesMillsSubtitle, UHLesMillsTitle } from './typography';
import ImagePlaceholder from './ImagePlaceholder';
import { getLesMillsContent } from './content';
import styles from './Manifesto.module.css';

const Manifesto = () => {
  const t = useTranslations('uhXLesMills');
  const { manifesto } = React.useMemo(() => getLesMillsContent(t), [t]);

  return (
    <section
      className={styles.section}
      role="region"
      aria-labelledby="lm-manifesto-heading"
    >
      <Container>
        <div className={styles.inner}>
          <div className={styles.heading}>
            <UHLesMillsTitle id="lm-manifesto-heading">
              <span className={styles.titleLine}>
                {t('manifesto.titleBright1')}
                <span className={styles.titleDim}>
                  {t('manifesto.titleDim1a')}
                </span>
              </span>{' '}
              <span className={styles.titleLine}>
                <span className={styles.titleDim}>
                  {t('manifesto.titleDim1b')}
                </span>{' '}
                {t('manifesto.titleBright2')}
              </span>{' '}
              <span className={styles.titleLine}>
                <span className={styles.titleDim}>
                  {t('manifesto.titleDim2')}
                </span>
              </span>
            </UHLesMillsTitle>
            <UHLesMillsSubtitle>{manifesto.subtitle}</UHLesMillsSubtitle>
          </div>
          <div className={styles.imageWrap}>
            <div className={styles.mediaFrame}>
              {manifesto.image ? (
                <img
                  className={styles.manifestoImage}
                  src={manifesto.image}
                  alt={manifesto.imageLabel}
                />
              ) : (
                <ImagePlaceholder
                  label={manifesto.imageLabel}
                  radius={16}
                  fill
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Manifesto;
